import React, { useEffect, useMemo, useState } from "react";
import "./styles/theme.css";
import "./App.css";
import AppHeader from "./components/AppHeader";
import FavoritesPanel from "./components/FavoritesPanel";
import HeroSection from "./components/HeroSection";
import MovieGrid from "./components/MovieGrid";
import TrailerModal from "./components/TrailerModal";
import { useMovies } from "./hooks/useMovies";
import { getMovieTitle } from "./utils/movieUtils";
import { reloadPage, scrollToTop } from "./utils/browser";

function App() {
  const [searchKey, setSearchKey] = useState("");
  const [playing, setPlaying] = useState(false);
  const {
    movies,
    selectedMovie,
    trailer,
    favorites,
    loading,
    searchLoading,
    error,
    isFavorite,
    searchMovies,
    selectMovie,
    addFavorite,
    removeFavorite,
  } = useMovies();

  const statusText = useMemo(() => {
    if (loading) return "Cargando catálogo...";
    if (error) return error;
    if (!movies.length) return "No encontramos películas para mostrar.";
    return "";
  }, [error, loading, movies.length]);

  const isTrailerOpen = playing && Boolean(trailer);

  const handleSearchSubmit = async (event) => {
    event.preventDefault();
    await searchMovies(searchKey);
    setPlaying(false);
  };

  const handleSelectMovie = async (movie) => {
    await selectMovie(movie);
    setPlaying(false);
    scrollToTop();
  };

  useEffect(() => {
    document.body.style.overflow = isTrailerOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isTrailerOpen]);

  return (
    <div className="app-shell">
      <AppHeader
        searchValue={searchKey}
        onSearchChange={setSearchKey}
        onSearchSubmit={handleSearchSubmit}
        onBrandClick={reloadPage}
        searching={searchLoading}
      />

      {statusText ? <p className="status-message glass-panel">{statusText}</p> : null}

      <main className="main-layout">
        <HeroSection
          movie={selectedMovie}
          hasTrailer={Boolean(trailer)}
          onPlayTrailer={() => setPlaying(true)}
          onAddFavorite={addFavorite}
          onRemoveFavorite={removeFavorite}
          isFavorite={isFavorite}
        />

        {isTrailerOpen ? (
          <TrailerModal
            trailer={trailer}
            title={getMovieTitle(selectedMovie)}
            onClose={() => setPlaying(false)}
          />
        ) : null}

        <section className="catalog-layout">
          <MovieGrid
            movies={movies}
            selectedMovieId={selectedMovie?.id}
            onSelect={handleSelectMovie}
            loading={loading}
          />
          <FavoritesPanel favorites={favorites} onSelect={handleSelectMovie} />
        </section>
      </main>
    </div>
  );
}

export default App;
